import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { PrestationsPage } from '@/features/prestations/components/PrestationsPage';

const prestationSearchSchema = z.object({
  accountingCategoryId: z.number().optional(),
});

export const Route = createFileRoute('/$commiteeSlug/prestation/')({
  component: RouteComponent,
  validateSearch: (search) => prestationSearchSchema.parse(search),
});

function RouteComponent() {
  const { accountingCategoryId } = Route.useSearch();
  return <PrestationsPage accountingCategoryId={accountingCategoryId} />;
}
